export function CallbackOnCLick<T>(props: {
  value: string;
  data: T;
  cb: (value: T) => void;
}) {
  if (!props.value) {
    return '-';
  }
  return (
    <span className="underline-on-hover" onClick={() => props.cb(props.data)}>
      {props.value}
    </span>
  );
}
